import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';

export const AutodetectApi = {
  index() {
    return http.get(`${orgPath()}/filters`).then((response) => response.data.data);
  },

  store(data) {
    return http.post(`${orgPath()}/filters`, data).then((response) => response.data.data);
  },
};

export const AutodetectStatusApi = {
  index() {
    return http.get(`${orgPath()}/filters/statuses`).then((response) => response.data.data);
  },
};

export const AutodetectTestApi = {
  store(data) {
    return http.post(`${orgPath()}/filters/test`, data).then((response) => response.data.data);
  },
};
